module.exports = __webpack_public_path__ + "static/media/nl.10d31cc2.svg";